import { Col, Row } from 'react-bootstrap';
import { PieChart } from 'react-minimal-pie-chart';
import styles from './CustomDonutChart.module.scss';

export interface IDonutChartData {
  color: string;
  title: string;
  value: number;
}

interface IProps {
  usageData: IDonutChartData[];
}

const ProtocolReportChart = (props: IProps) => {
  const { usageData } = props;

  if (usageData.length === 0) {
    return <></>;
  }

  return (
    <Row className='my-5 row-cols-1 row-cols-md-2'>
      <Col>
        {usageData
          .filter((data: IDonutChartData) => data.value > 0)
          .map((data: IDonutChartData, index: number) => (
            <div className={styles.legendItem} key={index}>
              <div
                className={styles.dot}
                style={{ backgroundColor: data.color }}
              />
              <div>
                {data.title} - {data.value}%
              </div>
            </div>
          ))}
      </Col>
      <Col>
        <PieChart
          lineWidth={45}
          style={{ height: '350px' }}
          data={usageData.filter((data: IDonutChartData) => data.value > 0)}
          animate
          label={({ dataEntry }) =>
            dataEntry.value > 2 ? dataEntry.value.toFixed(1) + '%' : ''
          }
          labelStyle={{
            fontSize: '4px',
          }}
          labelPosition={75}
        />
      </Col>
    </Row>
  );
};

export default ProtocolReportChart;
